module.exports = __webpack_public_path__ + "soundplay.gif?70257a890ebaca4fb6281be68b4c49d9";